import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";

interface LanguageOption {
  code: string;
  native_name: string;
}

interface QuestionTranslationsProps {
  languages?: LanguageOption[];
  activeLang: string;
  onActiveLangChange: (langCode: string) => void;
  questionTextI18n: Record<string, string>;
  onI18nChange: (lang: string, value: string) => void;
}

export const QuestionTranslations = ({
  languages,
  activeLang,
  onActiveLangChange,
  questionTextI18n,
  onI18nChange,
}: QuestionTranslationsProps) => {
  return (
    <div className="space-y-2 border rounded-md p-3">
      <div className="flex items-center justify-between">
        <Label>Translations</Label>
        <div className="w-48">
          <Select value={activeLang} onValueChange={onActiveLangChange}>
            <SelectTrigger>
              <SelectValue placeholder="Language" />
            </SelectTrigger>
            <SelectContent>
              {(languages || []).map((l) => (
                <SelectItem key={l.code} value={l.code}>
                  {l.native_name} ({l.code})
                </SelectItem>
              ))}
            </SelectContent>
          </Select>
        </div>
      </div>
      <div className="space-y-2">
        <Label>Localized Question ({activeLang})</Label>
        <Textarea
          value={questionTextI18n[activeLang] || ''}
          onChange={(e) => onI18nChange(activeLang, e.target.value)}
          placeholder="Translated question text"
          rows={3}
        />
      </div>
    </div>
  );
};

export default QuestionTranslations;

